namespace GeniuzPOS.Inventory {
    export interface IcStockAdjustOutForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        StkAdjCode: Serenity.LookupEditor;
        WhsId: Serenity.LookupEditor;
        AdjFg: Serenity.EnumEditor;
        StockTo: Serenity.StringEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        Remark: Serenity.TextAreaEditor;
        AdjustOutDtList: IcStockAdjustOutDtEditor;
    }

    export class IcStockAdjustOutForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockAdjustOut';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockAdjustOutForm.init)  {
                IcStockAdjustOutForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EnumEditor;
                var w4 = s.TextAreaEditor;
                var w5 = IcStockAdjustOutDtEditor;

                Q.initFormType(IcStockAdjustOutForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'RefDocNo1', w0,
                    'RefDocNo2', w0,
                    'StkAdjCode', w2,
                    'WhsId', w2,
                    'AdjFg', w3,
                    'StockTo', w0,
                    'PostFg', w3,
                    'CancelFg', w3,
                    'Remark', w4,
                    'AdjustOutDtList', w5
                ]);
            }
        }
    }
}
